import $ from 'jquery'
import { Core } from './core'

export class Link {

  constructor () {
    if (Core.isAdmin()) return

    this.$body = $('body')

    this.$body.on('click', '[data-ob]', this.handleClickHiddenLink.bind(this))
  }

  handleClickHiddenLink (e) {
    let $link = $(e.currentTarget)
    let link = $link.data('ob')

    if (link.length) {
      e.preventDefault()

      link = atob(link)

      if ($link.data('target') === '_blank' ) {
        window.open(link)
      } else {
        location.href = link
      }
    }
  }
}
